class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    const searchParams = new URLSearchParams(window.location.search);

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const formData = JSON.parse(serializeForm(this.form));
    const {
      id,
      quantity,
      _pre,
      _pre_order_announcement,
      note,
      gift_id,
      cart_upsell,
      free_gift,
      quick_add,
    } = formData;
    const properties = {};
    let items = { items: [] };

    searchParams.forEach((val, key) => {
      switch (key) {
        case 'internal_referral':
          properties._internal_referrer = val;
          break;
        case 'utm_source':
          properties._utm_source = val;
          break;
        case 'utm_medium':
          properties._utm_medium = val;
          break;
        case 'utm_campaign':
          properties._utm_campaign = val;
          break;
        case 'utm_term':
          properties._utm_term = val;
          break;
        case 'utm_content':
          properties._utm_content = val;
          break;
        case 'campaign_id':
          properties._campaign_id = val;
          break;
        case 'ad_id':
          properties._ad_id = val;
          break;
        case 'section_clicked':
          properties._section_clicked = val;
          break;
        case 'section_source':
          properties._section_source = val;
          break;
        case '_ab_croboost':
          properties._ab_croboost = val;
          break;
      }
    });
    if (cart_upsell) {
      properties._add_type = 'cart_upsell_add';
    } else if (quick_add) {
      properties._add_type = 'quick_add';
    } else if (free_gift) {
      properties._add_type = 'free_gift';
    } else {
      properties._add_type = 'normal_add';
    }
    properties._scroll_depth = localStorage.scroll_deapth + '%';
    cart_upsell ? (properties._cart_upsell = true) : null;
    free_gift ? (properties._free_gift = true) : null;
    _pre ? (properties._pre = _pre) : null;
    _pre_order_announcement
      ? (properties._pre_order_announcement = _pre_order_announcement)
      : null;
    // pre_order_expected_date ? properties.pre_order_expected_date = pre_order_expected_date : null;
    note ? (properties.note = note) : null;
    gift_id ? (properties._gift_id = gift_id) : null;
    const alerdyAdded = gift_id
      ? this.cartNotification.querySelector(
          '.bc-cart__item[data-id="' + gift_id + '"]'
        )
      : null;

    var upsellScope = this.closest('.shopify-section') || document;
    var upsellCheck =
      upsellScope.querySelector('.pdp-upsell .ProductUpsell__Check') ||
      upsellScope.querySelector('.ProductUpsell__Check');
    if (upsellCheck != null && upsellCheck.checked == true) {
      var upsellRoot =
        upsellCheck.closest('.pdp-upsell') ||
        upsellCheck.closest('.ProductUpsell') ||
        upsellScope;
      var upsellVariantEl = upsellRoot.querySelector(
        '.ProductUpsell__Variants'
      );
      var upsellId = upsellVariantEl
        ? upsellVariantEl.value
        : upsellCheck.value;
      if (upsellId) {
        items.items.push({
          id: upsellId,
          quantity: 1,
          properties: { _upsell: true },
        });
      }
    }
    if (isNaN(gift_id) || alerdyAdded || alerdyAdded !== null) {
      items.items.push({ id: id, quantity: quantity, properties: properties });
    } else {
      items.items.push({ id: id, quantity: quantity, properties: properties });
      items.items.push({ id: gift_id, properties: { _gift: true } });
      //items = {'items': [{'id': id, 'quantity': quantity, 'properties': properties},{'id': gift_id, 'properties': {'_gift': true} }]};
    }
    const body = JSON.stringify(items);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((data) => {
        this.cartNotification.getCart();
        this.cartNotification.classList.add('new-item-added');
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);

document.querySelectorAll('.add_bundle_item').forEach((item) => {
  item.addEventListener('click', function () {
    const searchParams = new URLSearchParams(window.location.search);
    var parent_wraper = this.closest('.product__info-wrapper');
    var items = { items: [] };
    this.setAttribute('disabled', true);
    this.classList.add('loading');
    var custom_property = this.dataset.property || true;
    var cartNotification = document.querySelector('cart-notification');
    parent_wraper.querySelectorAll('product-form form').forEach((i_form) => {
      var formData = JSON.parse(serializeForm(i_form));
      var {
        id,
        quantity,
        _pre,
        _pre_order_announcement,
        note,
        gift_id,
        cart_upsell,
        free_gift,
      } = formData;
      var properties = {};
      searchParams.forEach((val, key) => {
        switch (key) {
          case 'internal_referral':
            properties._internal_referrer = val;
            break;
          case 'utm_source':
            properties._utm_source = val;
            break;
          case 'utm_medium':
            properties._utm_medium = val;
            break;
          case 'utm_campaign':
            properties._utm_campaign = val;
            break;
          case 'utm_term':
            properties._utm_term = val;
            break;
          case 'utm_content':
            properties._utm_content = val;
            break;
          case 'campaign_id':
            properties._campaign_id = val;
            break;
          case 'ad_id':
            properties._ad_id = val;
            break;
          case 'section_click':
            properties._section_click = val;
            break;
          case 'section_source':
            properties._section_source = val;
            break;
          case '_ab_croboost':
            properties._ab_croboost = val;
            break;
        }
      });
      // _pre ? properties._pre = _pre : null;
      // note ? properties.note = note : null;
      properties._bundle = custom_property;
      properties._scroll_depth = localStorage.scroll_deapth + '%';
      items.items.push({ id: id, quantity: quantity, properties: properties });
    });
    const body = JSON.stringify(items);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((data) => {
        cartNotification.getCart();
        cartNotification.classList.add('new-item-added');
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.classList.remove('loading');
        this.removeAttribute('disabled');
      });
  });
});
